import { BareActionContext } from 'vuex-typex'
import { ConvoState } from '../state'
import { RootState } from '../..'
import { IConvo } from '@/model/convo'
import convoStore from '../convo-store'

export default async function copyConvo(context: BareActionContext<ConvoState, RootState>, convo: IConvo)
{
    convoStore.commitCopyConvo({ convo: convo })

    return
}
